import i18n from "@/i18n";

export default {
  headers: [
    {
      text: i18n.t("crudRooms.hCenterName"),
      value: "room.center.name",
      sortable: true,
    },
    {
      text: i18n.t("crudRooms.hName"),
      value: "room.name",
      sortable: true,
    },
    {
      text: i18n.t("crudDesks.hName"),
      value: "name",
      sortable: true,
    },
    {
      text: i18n.t("crudDesks.deskType"),
      value: "deskType",
      sortable: true,
    },
    {
      text: i18n.t("crudRooms.hAvailable"),
      value: "available",
      sortable: true,
    },
    {
      text: i18n.t("crudRooms.hActions"),
      value: "actions",
      align: "center",
      sortable: false,
    },
  ],
  locale: {
    title: i18n.t("crudDesks.title"),
    search: i18n.t("crudDesks.search"),
    deleteConfirm: i18n.t("crudDesks.deleteConfirm"),
    newItem: i18n.t("crudDesks.newDesk"),
    updateItem: i18n.t("crudDesks.updateDesk"),
  },
};
